module.exports = __webpack_public_path__ + "img/pauseicon.2fc37679.svg";